<template>
  <layout :session="session">
    <div
      class="mt-2 sm:mt-6 flex flex-col justify-between items-center px-4 py-2 sm:py-5 text-center"
    >
      <!-- <div class="flex-1">
        <p class="mt-2 text-2xl font-extralight">Result1</p>
      </div> -->

      <result :session="session" :ratings="ratings" :resultIdx="step == 'result1' ? 1 : 2"></result>
    </div>

    <template v-slot:footer
      >
      <a
        :href="route('control-panel.phase', { sessionUuid: session.uuid, phaseId: currentPhaseId, step: nextStep })"
        class="inline-flex justify-center w-full sm:w-min rounded-none sm:rounded-md border border-transparent px-3 py-1.5 sm:my-2 sm:px-2 sm:py-2 bg-brandpreneurship-dark-gray text-base leading-6 font-medium text-white shadow-sm hover:bg-black focus:outline-none focus:border-black focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5 z-50"
        >WEITER</a
      >
      </template
    >
  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';
import Result from '@/Pages/LiveResults/Productivity/Result';

export default {
  metaInfo() {
    return {
      title: ``,
    };
  },

  components: {
    Layout,
    Result,
  },

  props: ['session', 'phase', 'currentPhaseId', 'nextPhaseId', 'step', 'nextStep', 'ratings', 'translations'],

  computed: {},
};
</script>